import { Component, Host, h, Prop, State, Event, Method, Watch } from '@stencil/core';

@Component({
  tag: 'jump-filtergroup',
  styleUrl: 'jump-filtergroup.scss',
  shadow: true,
})
export class JumpFiltergroup {
  @Prop() name: string = 'tax-name';
  @Prop() heading: string = 'Titolo del filtro';
  @Prop() otherLabel: string = 'Mostra altro';
  @Prop() lessLabel: string = 'Mostra meno';
  @Prop() maxElements: number = 8;
  //TODO: Add Accordion variant within jump-acccordion component
  @Prop() variant: 'accordion' | 'default' = 'default';

  @State() label: string = this.otherLabel;
  @State() values: string[] = [];
  @State() value: string = '';
  @State() slotItems: any;
  @State() inputs: any = [];
  @State() showMore: boolean = false;

  @Event({ eventName: 'jump-filterchange' }) change;

  slotItemsWrapper: HTMLSlotElement;
  showMoreBtn: HTMLElement;

  @Watch('showMore')
  watchShowMore(newValue: boolean) {
    this.label = newValue ? this.lessLabel : this.otherLabel;
  }

  @Method('getValues')
  async getValues() {
    return this.values;
  }

  @Method('getActiveAmount')
  async getActiveAmount() {
    return this.values.length;
  }

  @Method('getInputs')
  async getInputs() {
    return this.inputs;
  }

  @Method('getName')
  async getName() {
    return this.name;
  }

  toggleHiddenItems() {
    this.slotItemsWrapper.assignedElements().forEach((item, index) => {
      if (index > this.maxElements) {
        if (this.showMore) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      }
    });
  }

  handleShowMore() {
    this.showMore = !this.showMore;
    this.toggleHiddenItems();
  }

  handleChange(event: Event) {
    const target = event.target as HTMLInputElement | HTMLSelectElement;
    const newValue = target.value;

    if (target.tagName === 'INPUT') {
      if (target.type === 'checkbox') {
        // @ts-ignore
        if (target.checked) {
          this.values.push(newValue);
        } else {
          const index = this.values.indexOf(newValue);
          if (index !== -1) {
            this.values.splice(index, 1);
          }
        }
      } else if (target.type === 'radio') {
        // Se è un input radio selezionato, imposta il valore e aggiorna this.values
        this.value = newValue;
        this.values = [newValue]; // Assicurati che this.values contenga solo il valore selezionato
      }
    } else if (target.tagName === 'SELECT') {
      // Se è un select, aggiorna semplicemente il valore
      this.value = newValue;
      this.values = [newValue];
    }

    // Emit event con i valori aggiornati
    this.change.emit({
      name: this.name,
      values: this.values,
    });
  }

  handleCheckboxChange(event: CustomEvent) {
    if (event.detail.checked && !this.values.includes(event.detail.value)) {
      this.values.push(event.detail.value);
    } else if (!event.detail.checked && this.values.includes(event.detail.value)) {
      const index = this.values.indexOf(event.detail.value);
      if (index !== -1) {
        this.values.splice(index, 1);
      }
    }
    this.change.emit({
      name: this.name,
      values: this.values,
    });
  }

  componentDidLoad() {
    this.slotItems = this.slotItemsWrapper.assignedElements();
    this.slotItemsWrapper.addEventListener('change', this.handleChange.bind(this));
    this.slotItemsWrapper.addEventListener('jump-checkbox-change', this.handleCheckboxChange.bind(this));

    let index = 0;
    this.slotItems.forEach((item) => {
      item.classList.add('item');
      if (index > this.maxElements) {
        item.classList.add('hidden');
      }
      //if (item.tagName start with jump-
      if (item.tagName === 'INPUT' || item.tagName === 'SELECT' || item.tagName.startsWith('JUMP-') || item.tagName === 'LABEL') {
        this.inputs.push(item);
        if (item.tagName === 'INPUT' && item.type === 'radio') {
          item.name = this.name;
        }
      } else {
        const inputs = item.querySelectorAll('input, select');
        if (inputs.length > 0) {
          inputs.forEach((input) => {
            this.inputs.push(input);

            if (input.tagName === 'INPUT' && input.type === 'radio') {
              input.name = this.name;
            }
          });
        }
      }
      index++;
    });

    //this.toggleHiddenItems();
  }

  render() {
    return (
      <Host>
        {this.heading && <h5>{this.heading}</h5>}
        <div class="filterGroup">
          <slot ref={(el) => (this.slotItemsWrapper = el as HTMLSlotElement)}></slot>
        </div>
        {this.inputs.length > this.maxElements &&
          <jump-button variant="primary" size="small" text name={this.label}
                       aria-label={this.label}
                       ref={(showMoreBtn) => {
                         this.showMoreBtn = showMoreBtn;
                       }}
                       onClick={() => this.handleShowMore()}>
            {this.label}
            <jump-icon slot="suffix" name={!this.showMore ? 'chevron-down' : 'chevron-up'}></jump-icon>
          </jump-button>
        }
      </Host>
    );
  }
}
